import {
  useGetUrl,
  translations as utilsTranslations,
} from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Text, Stack, Disclosure } from 'braid-design-system';

import { ExternalLink } from 'src/components/ExternalLink/ExternalLink';
import { useAppConfig } from 'src/modules/appConfig';

import { useResumePrivacyDisclaimers } from '../../../data';

import translations from './.vocab';

export const PrivacyInfo = () => {
  const { resumePrivacyDisclaimers } = useResumePrivacyDisclaimers();

  const { t } = useTranslations(translations);
  const { zone, language } = useAppConfig();

  const privacyTranslations =
    utilsTranslations.getLoadedResumePrivacyDisclaimerMessages(language);

  const translatedPrivacyStatementMessage =
    privacyTranslations[
      'By uploading documents, you agree to our Collection Notice and Privacy Statement.'
    ].format();

  const getUrl = useGetUrl(zone, language);

  return (
    <Stack space="medium">
      <Text>
        {resumePrivacyDisclaimers &&
          resumePrivacyDisclaimers.shortParagraphs[0].value}
      </Text>
      <Disclosure
        expandLabel={t('More about privacy and data use')}
        collapseLabel={t('More about privacy and data use')}
        id="readmore"
        weight="weak"
      >
        <Stack space="medium">
          {resumePrivacyDisclaimers &&
            resumePrivacyDisclaimers.longParagraphs.map((copy, index) => {
              if (copy.isEmphasized) {
                return (
                  <Text weight="strong" key={`${copy.value}-${index}`}>
                    {copy.value}
                  </Text>
                );
              }
              if (
                copy.value.indexOf(translatedPrivacyStatementMessage) !== -1
              ) {
                // Find and replace Privacy Statement paragraph to add links:
                return (
                  <Text key={`${copy.value}-${index}`}>
                    {privacyTranslations[
                      'By uploading documents, you agree to our Collection Notice and Privacy Statement. [with links]'
                    ].format({
                      CollectionNoticeLink: (v) => (
                        <ExternalLink
                          target="_blank"
                          rel="noopener noreferrer"
                          href={getUrl('collection-notice')}
                        >
                          {v}
                        </ExternalLink>
                      ),
                      PrivacyStatementLink: (v) => (
                        <ExternalLink
                          target="_blank"
                          rel="noopener noreferrer"
                          href={getUrl('profile-privacy')}
                        >
                          {v}
                        </ExternalLink>
                      ),
                    })}
                  </Text>
                );
              }
              return <Text key={`${copy.value}-${index}`}>{copy.value}</Text>;
            })}
        </Stack>
      </Disclosure>
    </Stack>
  );
};
